
(() => {
  const modal = document.querySelector('[data-enquiry-modal]');
  if (!modal) return;

  const title = modal.querySelector('[data-enquiry-title]');
  const text = modal.querySelector('[data-enquiry-text]');
  const typeSelect = modal.querySelector('[data-enquiry-type]');

  const locationFields = modal.querySelectorAll('[data-enquiry-location]');
  const dimensions = modal.querySelector('[data-enquiry-dimensions]');

  const variantInput = modal.querySelector('[data-enquiry-variant]');
  const skuInput = modal.querySelector('[data-enquiry-sku]');
  const variantLabel = modal.querySelector('[data-enquiry-variant-label]');

  let lastTrigger = null;

  const open = (trigger) => {
    lastTrigger = trigger || document.activeElement;
    modal.hidden = false;
    document.body.classList.add('overflow-hidden');
    modal.querySelector('[data-enquiry-close]')?.focus();
  };

  const close = () => {
    modal.hidden = true;
    document.body.classList.remove('overflow-hidden');
    lastTrigger?.focus?.();
  };

  const updateForm = () => {
    if (!typeSelect) return;

    const option = typeSelect.selectedOptions[0];
    if (!option) return;

    if (title) {
      title.textContent = option.dataset.title || 'How can we help?';
    }

    if (text) {
      text.textContent = option.dataset.text || '';
    }

    // Keep Postcode and Suburb visible for all enquiry types.
    // Require them only for Delivery Quote.
    const needsLocation = option.hasAttribute('data-location-required');

    locationFields.forEach((field) => {
      field.required = needsLocation;
    });

    // Show dimensions for relevant enquiry types.
    if (dimensions) {
      const needsDimensions = option.hasAttribute('data-dimensions-required');

      dimensions.hidden = !needsDimensions;

      const input = dimensions.querySelector('input');
      if (input) input.required = needsDimensions;
    }
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-enquiry-open]');

    if (trigger) {
      event.preventDefault();
      open(trigger);
      return;
    }

    if (
      event.target.closest('[data-enquiry-close]') ||
      event.target === modal
    ) {
      close();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !modal.hidden) {
      close();
    }
  });

  // Update the selected product variant.
  document.addEventListener('variant:change', ({ detail }) => {
    const variant = detail?.variant;
    if (!variant) return;

    if (variantInput) {
      variantInput.value = variant.title || '';
    }

    if (skuInput) {
      skuInput.value = variant.sku || '';
    }

    if (variantLabel) {
      const variantTitle =
        variant.title === 'Default Title' ? '' : variant.title || '';

      variantLabel.textContent = variantTitle;
      variantLabel.hidden = !variantTitle;
    }
  });

  typeSelect?.addEventListener('change', updateForm);
  updateForm();


  // Reopen the drawer after Shopify returns a form response.
  const hasFormResponse = modal.querySelector(
    '[data-enquiry-success], [data-enquiry-errors]'
  );

  if (hasFormResponse) {
    open();
  }
})();

